import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const l = i((r, e) => /* @__PURE__ */ o.jsx(
  s,
  {
    ref: e,
    ...r,
    image: (t) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...t,
        children: [
          /* @__PURE__ */ o.jsx(
            "circle",
            {
              cx: 12,
              cy: 12,
              r: 10.5,
              stroke: "currentColor",
              strokeWidth: 3
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M12 12.298 14.798 9.5 16 10.702l-4 4-4-4L9.202 9.5z",
              clipRule: "evenodd"
            }
          )
        ]
      }
    )
  }
));
l.displayName = "AccordionCaretDownIcon";
export {
  l as AccordionCaretDownIcon,
  l as default
};
//# sourceMappingURL=index.js.map
